/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3HIcon32Regular = forwardRef('UiMenuDots3HIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M5 16a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z" }),
        React.createElement("path", { d: "M16 18a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z" }),
        React.createElement("path", { d: "M25 18a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z" })));
});
